import { AutogenLayoutEdiMapErrors } from "./autogen/AutogenLayoutEdiMapErrors";
import {  DataSourceExecutionEvent, DataSourceMode } from "@mcleod/components";

export class EdiMapErrors extends AutogenLayoutEdiMapErrors {

/** This is an event handler for the afterExecution event of sourceEdiMapError. */
  sourceEdiMapErrorAfterExecution(event: DataSourceExecutionEvent) {
    const transType = this.sourceEdiMapError.layoutName.includes("EdiStatus")?"S":this.sourceEdiMapError.layoutName.includes("EdiBilling")?"I":"T";
    this.sourceEdiMapError.setRowsAndMode(DataSourceMode.NONE, (this.sourceEdiMapError.data.filter(error => error.data["transaction_type"] === transType)));
  }
}
